import { render, staticRenderFns } from "./send_auth.vue?vue&type=template&id=16c1f672&lang=pug&"
import script from "./send_auth.vue?vue&type=script&lang=js&"
export * from "./send_auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports